@import '../../../globals/variables';

/**
 * THEME JSON CONFIG CSS VARS
 * The following default component scss variables can be overwritten via theme configuration per brand.
 * If you need to add new one, please make sure to set a default value.
 * JSON Definition for Component with name "Example": testCssVar: "20px"
 * Resulting CSS var: $example-test-css-var: 20px;
 */

$radio-button-label-margin-top: 0px !default;
$radio-button-small-label-margin-top: 0px !default;
$radio-button-border-width: 2px !default;
$radio-button-small-border-width: 2px !default;
$radio-button-svg-size: 22px !default;
$radio-button-svg-size-small: 22px !default;
$radio-button-dot-size: 10px !default;
$radio-button-dot-size-small: 10px !default;
$radio-button-label-margin-left: 8px !default; // distance between radio and the labels
$radio-button-label-font-size: 18px !default;
$radio-button-small-label-font-size: 14px !default;
$radio-button-label-line-height: 27px !default;
$radio-button-small-label-line-height: 21px !default;

/* END THEME JSON CONFIG CSS VARS ******************************************************* */

:host {
  display: inline-block;
}

:host([disabled]:not([disabled="false"])) {
  cursor: not-allowed;
  label {
    @include disabled();
  }
}

envc-eon-ui-rte-renderer {
  --rteRendererLineHeight: #{$radio-button-label-line-height};
}

.#{$prefix}radio-button-wrapper {
  position: relative;
  display: flex;
  align-items: flex-start;
  box-sizing: border-box;

  * {
    box-sizing: border-box;
  }

  .#{$prefix}radio-button-label {
    position: relative;
    width: auto;
    max-width: 100%;
    font-family: $font-family-base;
    cursor: pointer;
    outline: none;
    display: inline-flex;
    justify-content: flex-start;
    align-items: flex-start;
    box-sizing: border-box;
    gap: $radio-button-label-margin-left;
    font-size: $radio-button-label-font-size;
    line-height: $radio-button-label-line-height;
    color: v(labelColor);
    margin-bottom: 0;

    .#{$prefix}text {
      position: relative;
      //@include iconTextAligner($radio-button-svg-size, $radio-button-label-line-height); // ENVIAM
      //margin-bottom: calc(($radio-button-svg-size - $radio-button-label-line-height) / 2); // ENVIAM
      top: $radio-button-label-margin-top;
    }

    .#{$prefix}radio-button {
      position: relative;
      width: $radio-button-svg-size;
      height: $radio-button-svg-size;
      border-radius: 100%;
      border: $radio-button-border-width solid v(uncheckedColor);
      flex-shrink: 0;
      // ENVIAM
      display: inline-flex;
      justify-content: center;
      align-items: center;

      &::before {
        content: "";
        position: relative;
        width: $radio-button-dot-size;
        height: $radio-button-dot-size;
        border-radius: 100%;
        background: v(uncheckedHoverColor);
        transform: scale(0);
        transition: transform 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275), opacity 0.15s linear;
        flex-shrink: 0;

        // ENVIAM
        border: 1px solid transparent;
      }
    }

    @media (pointer: fine) {
      &:not(.eonui-disabled):hover,
      &:not(.eonui-disabled).#{$prefix}force-hover {
        .#{$prefix}radio-button {
          border-width: calc($radio-button-border-width + 1px);

          // ENVIAM
          border-color: v(checkedColor);
          // /ENVIAM

          &::before {
            //opacity: 0.5;
            transform: scale(1);
            border-color: v(outlineColor);
          }
        }

        .#{$prefix}text {
          //text-decoration: underline;
        }

        &.#{$prefix}checked {
          .#{$prefix}radio-button {
            border-width: calc($radio-button-border-width + 1px);

            &::before {
              //opacity: 0.5;

              // ENVIAM
              background: v(checkedHoverColor);
              border-color: v(outlineColor);
            }
          }
        }
      }
    }

    &.#{$prefix}checked {
      .#{$prefix}radio-button {
        border-color: v(checkedColor);

        &::before {
          transform: scale(1);
          background-color: v(checkedColor);
        }
      }
    }

    &.#{$prefix}error {
      // ENVIAM not only on checked make button red
      .#{$prefix}radio-button {
        border-color: v(errorColor);

        &::before {
          background-color: v(errorColor);
        }
      }
    }

    &.#{$prefix}disabled {
      cursor: not-allowed;
      //opacity: 0.5;

      .#{$prefix}radio-button {
        border-color: v(disabledLabelColor);

        &::before {
          background-color: v(disabledLabelColor);
        }
      }

      // ENVIAM
      .#{$prefix}text {
        color: v(disabledLabelColor);
      }
    }

    .#{$prefix}focus-outline {
      position: absolute;
      top: -5px;
      left: -5px;
      height: calc(100% + 10px);
      width: calc(100% + 10px);
      border: 3px solid v(focusColor); // ENVIAM 2->3px
      //border-radius: 10px; // ENVIAM
      opacity: 0;
      pointer-events: none;
      user-select: none;
    }

    .#{$prefix}native-control {
      top: 0;
      right: 0;
      left: 0;
      width: 100%;
      height: 0;
      position: absolute;
      opacity: 0;
      cursor: inherit;
      z-index: 1;
      margin: 0;
      padding: 0;
      flex-shrink: 0;
      flex-grow: 0;

      &.#{$prefix}safari:focus ~ .#{$prefix}focus-outline,
      &:focus-visible ~ .#{$prefix}focus-outline {
        opacity: 1;
      }
    }
  }

  .#{$prefix}radio-button-info-icon {
    margin-left: 12px;
    // @include iconTextAligner($radio-button-svg-size, 20px); // ENVIAM
  }

  &.#{$prefix}small {
    .#{$prefix}radio-button-label {
      font-size: $radio-button-small-label-font-size;
      line-height: $radio-button-small-label-line-height;

      .#{$prefix}text {
        @include iconTextAligner($radio-button-svg-size-small, $radio-button-small-label-line-height);
        margin-bottom: calc(($radio-button-svg-size-small - $radio-button-small-label-line-height) / 2);
        top: $radio-button-small-label-margin-top;
      }

      .#{$prefix}radio-button {
        width: $radio-button-svg-size-small;
        height: $radio-button-svg-size-small;
        border-radius: calc($radio-button-svg-size-small / 2);
        border-width: $radio-button-small-border-width;

        &::before {
          width: $radio-button-dot-size-small;
          height: $radio-button-dot-size-small;
        }
      }

      @media (pointer: fine) {
      &:not(.eonui-disabled):hover,
      &:not(.eonui-disabled).#{$prefix}force-hover {
        .#{$prefix}radio-button {
          border-width: calc($radio-button-small-border-width + 1px);
        }

        &.#{$prefix}checked {
          .#{$prefix}radio-button {
            border-width: calc($radio-button-small-border-width + 1px);
          }
        }
      }
    }
    }

    .#{$prefix}radio-button-info-icon {
      @include iconTextAligner($radio-button-svg-size-small, 20px);
    }
  }
}
